const DizeeButton = ({ onClick, label, className }) => {
    return <p onClick={onClick} className={`text-white cursor-pointer ${className}`} style={{ fontSize: '12px' }}>{label}</p>;
  };
  
export default DizeeButton;
  